import script from "./SuperAdminSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperAdminSidebar.vue?vue&type=script&setup=true&lang=js"

import "./SuperAdminSidebar.vue?vue&type=style&index=0&id=3b8b7c3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b8b7c3e"]])

export default __exports__